import React, { createContext, useContext, useRef, useState } from 'react';
import GmModal from 'app/shared/modal/modal';
import { CreateOrganizationModal } from 'app/member/organization/create/modal';

const CreateOrganizationContext = createContext({ openCreateOrganization: () => {} });

export const useCreateOrganization = () => useContext(CreateOrganizationContext);

/**
 * Hosts a single Create-Organisation modal that any descendant (side nav, header
 * quick actions, the organisations module) can open via `openCreateOrganization`.
 * Pass `{ onCreated }` to be notified after a successful create (e.g. to refetch
 * a table).
 */
export const CreateOrganizationProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const on_created = useRef(null);

  const openCreateOrganization = (options = {}) => {
    on_created.current = options.onCreated || null;
    setShow(true);
  };

  const handleCreated = (org) => {
    if (on_created.current) on_created.current(org);
  };

  return (
    <CreateOrganizationContext.Provider value={{ openCreateOrganization }}>
      {children}
      <GmModal
        title="Create organisation"
        show_title
        show_modal={show}
        onClose={() => setShow(false)}
      >
        <CreateOrganizationModal onCreated={handleCreated} />
      </GmModal>
    </CreateOrganizationContext.Provider>
  );
};
